import { render, staticRenderFns } from "./AlertAction.vue?vue&type=template&id=8cdf0bce&"
import script from "./AlertAction.vue?vue&type=script&lang=js&"
export * from "./AlertAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports